<template>
    <div>
      <h2>Инструкция по приему платежей через Тинькофф</h2>
      <p>Оставить заявку на подключение <a href="https://www.tinkoff.ru/kassa/">сайт Тинькофф</a> </p>
      <p>Дождаться проверки магазина</p>
      <p>Получить настройки в Личном кабинете</p>
      <p>Ввести выданные настройки в личном кабинете в разделе "Настройки".(выбрать режим работы - Заказ и оплата)</p>
      <p>Выполнить тестовые платежи</p>
      <p>Подключить онлайн кассу и ОФД к платежной системе.</p>
      <p>Если потребуется помощь в интеграции, можем помочь все наладить, обращайтесь в техподдержку.</p>
      <br><br>
    </div>
</template>

<style>

</style>

<script>
export default {
  name: 'DocTinkoffView'
}
</script>
